import getHomecardsQuery from '../../common/graphql/queries/homecards';

const emptyHomecards = config => !config.homecards || !config.homecards.length;

export async function homecardsParser(config, locale, domain, graphqlClient) {
  if (emptyHomecards(config)) {
    return null;
  }
  const homecards = await getHomecardsQuery(graphqlClient)(
    config.homecards,
    locale
  );

  return {
    ...config,
    homecards: homecards.data.homecards.filter(homecard => homecard)
  };
}

export default {
  homecardsParser
};
